import { render, staticRenderFns } from "./group-notice.vue?vue&type=template&id=4b690560&"
import script from "./group-notice.vue?vue&type=script&lang=js&"
export * from "./group-notice.vue?vue&type=script&lang=js&"
import style0 from "./group-notice.vue?vue&type=style&index=0&id=4b690560&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports